import { render, staticRenderFns } from "./InvoicePrefixesTable.vue?vue&type=template&id=6f258370&"
import script from "./InvoicePrefixesTable.vue?vue&type=script&lang=js&"
export * from "./InvoicePrefixesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports